const jQuery = require('jquery');
const mapboxgl = require('mapbox-gl');

export default {
  init() {
    //console.log('showroom page');
    //add mapbox stylesheet
    jQuery('head').append('<link rel="stylesheet" type="text/css" href="https://api.tiles.mapbox.com/mapbox-gl-js/v0.53.1/mapbox-gl.css">');
    
  },
  finalize() {
    // JavaScript to be fired, after the init JS
    mapboxgl.accessToken = 'pk.eyJ1IjoiYWZzY29mbmMiLCJhIjoiY2p0eWh3Y3JqMTRjNDN6cGYxMnZyZ25mNCJ9.DvSH9M1vHOsLMHbTXtVznw';
    const mapLatham = new mapboxgl.Map({
      container: 'showroom-latham-map',
      style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
      center: [-73.730923, 42.738605], // starting position [lng, lat]
      zoom: 12 // starting zoom
    });
    const mapSaratoga = new mapboxgl.Map({
      container: 'showroom-saratoga-map',
      style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
      center: [-73.78831, 43.070063], // starting position [lng, lat]
      zoom: 12 // starting zoom
    });
    const mapQueensbury = new mapboxgl.Map({
      container: 'showroom-queensbury-map',
      style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
      center: [-73.6782477, 43.2952847], // starting position [lng, lat]
      zoom: 12 // starting zoom
    });
    
    var geojson = {
        "type": "FeatureCollection",
        "features": [{
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [-73.730923, 42.738605]
            },
            "properties": {
                "title": "Latham",
                "description": "Latham, NY showroom and headquarters",
                //"icon": "monument"
            }
        }, {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [-73.6782477, 43.2952847]
            },
            "properties": {
                "title": "Queensbury",
                "description": "Queensbury, NY showroom and office",
                //"icon": "harbor"
            }
        }, {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [-73.78831, 43.070063]
            },
            "properties": {
                "title": "Saratoga",
                "description": "Saratoga Springs, NY satellite showroom located in Concord Pools",
                //"icon": "harbor"
            }
        }]
    };
    
    //Latham Map
    // Add zoom and rotation controls to the map.
    mapLatham.addControl(new mapboxgl.NavigationControl());
    //add marker to map
    mapLatham.on('load', function () {
        geojson.features.forEach(function(marker) {
          if (marker.properties.title == 'Latham') {
            // create a HTML element for each feature
            var el = document.createElement('div');
            el.className = 'marker';
            
            // make a marker for each feature and add to the map
            new mapboxgl.Marker(el, {
                //offset: [-15, -45]
              })
              .setLngLat(marker.geometry.coordinates)
              .addTo(mapLatham);
          }  
        });
    });
    
    //Saratoga Map
    // Add zoom and rotation controls to the map.
    mapSaratoga.addControl(new mapboxgl.NavigationControl());
    //add marker to map
    mapSaratoga.on('load', function () {
        geojson.features.forEach(function(marker) {
          if (marker.properties.title == 'Saratoga') {
            // create a HTML element for each feature
            var el = document.createElement('div');
            el.className = 'marker';

            // make a marker for each feature and add to the map
            new mapboxgl.Marker(el)
              .setLngLat(marker.geometry.coordinates)
              .addTo(mapSaratoga);
          }  
        });
    });
    
    //Queensbury Map
    // Add zoom and rotation controls to the map.
    mapQueensbury.addControl(new mapboxgl.NavigationControl());
    //add marker to map
    mapQueensbury.on('load', function () {
        geojson.features.forEach(function(marker) {
          if (marker.properties.title == 'Queensbury') {
            // create a HTML element for each feature
            var el = document.createElement('div');
            el.className = 'marker';
            

            // make a marker for each feature and add to the map
            new mapboxgl.Marker(el)
              .setLngLat(marker.geometry.coordinates)
              .addTo(mapQueensbury);
          }  
        });
    });
    
  },
};



// WEBPACK FOOTER //
// ./src/routes/visitAShowroom.js